export enum FormErrorCode {
    UnknownError = 0,
    InvalidDataFromVirk = 1,
    CprLookupError = 2,
    ClinicLookupError = 3,
    UnknownXmlFormat = 4,
    MissingMunicipalityCodeInXml = 5,
    MissingCitizeninfoFromXml = 6,
    NameNotFound = 7,
    LastNameNotFound = 8,
    NameInvalid = 9,
    ResourceNotFound = 10,
    CaseNotFetched = 11,
    GpSystemCredentials = 12,
    ReceivingFromGpSystem = 13,
    InvalidDataFromGpSystem = 14,
    ThirdPartyError = 15,
    NoSenderToDoctor = 16,
    DigitalPostSender = 1000,
    DigitalPostReceiver = 1001
}
